import {
  Stepper,
} from '@mantine/core';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { finalScreenData } from 'src/constants';
import { useStyles } from './completed.styles';
import { ScreenWrapper } from '../../components';
import { ReactComponent as CompletedIcon } from '../../assets/icons/completed.svg';

const Completed = (): JSX.Element => {
  const { classes } = useStyles();
  const userDetails = useSelector((state:RootState) => state.account.userDetails);

  const getStatus = (currentStep: string) => finalScreenData.find((step) => step.steps.includes(currentStep));
  const displayInfo = getStatus(userDetails.currentStep)

  const getStepperPosition = () => {
    if (displayInfo?.status === 'pending') {
      return 1;
    } if (displayInfo?.status === 'approved') {
      return 2;
    } if (displayInfo?.status === 'setupComplete') {
      return 3;
    }
    return 1
  };
  const stepperPosition = getStepperPosition()

  return (
    <ScreenWrapper>
      <div className={`csMainContainer ${classes.paddingTop0}`}>
        <div className={classes.contentContainer}>
          <h2 className={`csHeading ${classes.textCenter}`}>
            {displayInfo?.title}
          </h2>
          <p className={classes.subTitle}>{displayInfo?.subTitle}</p>
          <img
            src={displayInfo?.icon}
            className={classes.verifiedImg}
            alt="verified"
          />
          <Stepper
            active={getStepperPosition()}
            breakpoint="sm"
            orientation="vertical"
            classNames={{
              step: classes.step,
              content: classes.stepperContent,
              stepWrapper: classes.stepWrapper,
              stepLabel: classes.stepLabel,
              stepDescription: classes.stepDescription,
            }}
            className={classes.stepperWrapper}
            completedIcon={<CompletedIcon />}
          >
            <Stepper.Step
              label={displayInfo?.stepsText[0].title}
              description={displayInfo?.stepsText[0].description}
              className={classes.stepOne}
            />
            <Stepper.Step
              label={displayInfo?.stepsText[1].title}
              description={displayInfo?.stepsText[1].description}
              className={stepperPosition > 1 ? classes.stepCompleted : classes.stepTwo}
            />
            <Stepper.Step
              label={displayInfo?.stepsText[2].title}
              description={displayInfo?.stepsText[2].description}
              className={stepperPosition === 3 ? classes.stepCompleted : classes.stepThree}
            />
          </Stepper>
        </div>
      </div>
    </ScreenWrapper>
  );
};

export default Completed;
